import { Paper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import Layout from 'components/Layout';

const useStyles = makeStyles(theme => ({
  wrapper: {
    padding: '23px 120px 166px 120px',
  },
  title: {
    fontSize: '50px',
    marginBottom: '22px',
  },
  update: {
    fontSize: '12px',
    marginBottom: '22px',
  },
  subTitle: {
    fontSize: '16px',
    color: theme.palette.secondary.main,
    fontWeight: 'bold',
    letterSpacing: '0.125rem',
    textTransform: 'uppercase',
    marginBottom: '0px!important',
    paddingTop: '0.5rem',
  },
  paper: {
    padding: '26px 149px',
    '& > *': {
      marginBottom: '1.5rem',
    },
    '& ::marker': {
      color: theme.palette.secondary.main,
    },
  },
}));
const TermsOfUse: React.FC = () => {
  const classes = useStyles();
  return (
    <Layout noMenu>
      <div className={classes.wrapper}>
        <Typography variant="h1" className={classes.title}>
          Conditions Générales d'Utilisation<br></br>de la Plateforme e-tem²
        </Typography>
        <Typography className={classes.update}>Mise à jour le 01/04/2021</Typography>
        <Paper elevation={1} variant="outlined" className={classes.paper}>
          <Typography>
            La société CITEO est heureuse de vous accueillir sur la plateforme « e-tem² » (ci-après désigné « la
            Plateforme »).
          </Typography>
          <Typography>
            CITEO a pour mission d’organiser la collecte, le tri et le recyclage des emballages et papiers graphiques.
            Elle est notamment l’intermédiaire entre les collectivités, les opérateurs de collecte, les centres de tri
            et les centres de recyclage.
          </Typography>
          <Typography>
            CITEO a deux activités principales :
            <ul>
              <li>
                <strong>Citeo Eco-organisme : </strong>en charge de l’organisation, du pilotage et du développement de
                la collecte, du tri et du recyclage des emballages ménagers et des papiers graphiques mis sur le marché
                en France dans le cadre de la responsabilité élargie du producteur.
              </li>
              <li>
                <strong>Citeo Repreneur : </strong>en charge de la reprise du
                <strong> « flux développement ».</strong>
              </li>
            </ul>
          </Typography>
          <Typography>
            Parmi les flux de matières générés à la sortie des centres de tri, compte un flux de plastiques particulier
            dit « flux développement ». En termes de process de tri, ce flux particulier nécessite, en plus du tri
            primaire, une étape de tri complémentaire, dite « surtri », dans des installations spécialisées.
          </Typography>
          <Typography>
            <strong>
              Conformément à son agrément, CITEO s’est positionnée sur le flux développement pour en assurer la prise en
              charge financière et opérationnelle à la sortie du Centre de tri.
            </strong>{' '}
            CITEO intervient dans ce cadre <strong>en tant que repreneur du flux développement</strong>, et non en tant
            qu’éco-organisme au sens strict, chargé notamment de l’organisation et de pilotage de la filière des déchets
            d’emballages ménagers.
          </Typography>
          <Typography>
            Dans le cadre de son activité particulière de reprise du
            <strong> flux développement</strong>, CITEO a souhaité mettre en place une plateforme numérique de gestion
            et pilotage de l’opérationnalité du flux.
          </Typography>
          <Typography>
            Cette plateforme numérique permettra dans un premier temps de :
            <ul>
              <li>Gérer les demandes d’enlèvement, le transport, la livraison et la réception des déchets</li>
            </ul>
            Elle évoluera ensuite pour permettre de :
            <ul>
              <li>Gérer le stockage des déchets et les opérations de tri ou recyclage</li>
              <li> Gérer le suivi de la conformité des déchets (audits)</li>
              <li>Gérer la préfacturation et le suivi des paiements et pénalités</li>
              <li> Calculer la compensation pour les Collectivités </li>
            </ul>
          </Typography>
          <Typography>
            Elle permet également, à partir des données intégrées à la Plateforme, d’avoir connaissance des informations
            suivantes:
            <br />
            <ul>
              <li>Coordonnées des interlocuteurs intervenant dans une transaction ;</li>
              <li>Coordonnées des interlocuteurs Citeo ;</li>
              <li>Historique des actions réalisées sur la Plateforme.</li>
            </ul>
            <strong>
              Les Conditions générales d’utilisation ont pour objet de définir les conditions dans lesquelles CITEO
              permet aux Utilisateurs d’accéder et d’utiliser la Plateforme. Elles sont applicables à compter de leur
              mise en ligne et pendant toute la durée de mise à disposition de la Plateforme par CITEO.
            </strong>
          </Typography>
          <Typography>
            <strong>
              L’utilisation de la Plateforme est gratuite, hormis le coût de connexion internet qui reste à la charge de
              l’Utilisateur.
            </strong>
          </Typography>
          <Typography variant="h3" className={classes.subTitle}>
            Information légales
          </Typography>
          <Typography>
            <strong>Editeur : </strong>la Plateforme est éditée par CITEO société anonyme, au capital de 499 444,50
            euros, RCS Paris n° 388 380 073, dont le siège social est 50 boulevard Haussmann, 75009 paris, France -
            numéro de téléphone : 01 81 69 06 00 et adresse email : info@citeo.com.
          </Typography>
          <Typography>
            <strong>Directeur de la publication : </strong>Jean HORNAIN, Directeur Général de CITEO
          </Typography>
          <Typography>
            <strong>Hébergeur : </strong>Société Microsoft France, au capital de 4 240 000 € RCS Nanterre, sous le
            numéro B 327 733 184 dont le siège social est 37 QUAI DU PRESIDENT ROOSEVELT 92130 ISSY-LES-MOULINEAUX,
            numéro de téléphone : 09 70 01 90 90
          </Typography>
          <Typography>
            <strong>Réalisation et Développement : </strong>La Plateforme a été réalisé et développée par CITEO et ses
            prestataires.
          </Typography>
          <Typography variant="h3" className={classes.subTitle}>
            Definitions
          </Typography>
          <Typography>
            <strong>Conditions générales d’utilisation : </strong>désigne les présentes conditions générales
            d’utilisation (ou CGU) qui ont pour objet de définir les modalités et conditions dans lesquelles les
            Utilisateurs accèdent et utilisent la Plateforme.
          </Typography>
          <Typography>
            <strong>Données : </strong>désigne les données renseignées par les Utilisateurs sur la Plateforme,
            nécessaires à la gestion et au pilotage du flux développement.
          </Typography>
          <Typography>
            <strong>Plateforme : </strong>désigne la présente plateforme destinée à gérer et piloter le flux
            développement.
          </Typography>
          <Typography>
            <strong>Utilisateur : </strong>désigne les personnes physiques ou morales disposant d’un compte utilisateur
            sur la Plateforme. La Plateforme comporte plusieurs catégories d’Utilisateurs comme suit :
            <ul>
              <li>
                <strong>CITEO : </strong>désigne l’entité en charge de la reprise du flux développement et
                administrateur de la Plateforme. CITEO intervient dans ce cadre uniquement en tant que repreneur du flux
                développement ;
              </li>
              <li>
                <strong>Collectivité : </strong>désigne la collectivité locale, en général une intercommunalité
                (métropoles, communautés d’agglomération, syndicats de traitement, …), sous contrat avec CITEO pour la
                reprise de son flux développement ;
              </li>
              <li>
                <strong>Centre de tri : </strong>désigne l’entité sous contrat avec CITEO qui procède à une opération de
                surtri du flux développement et qui produit les standards sur-triés associés. Le Centre de surtri
                expédie des déchets à destination des Recycleurs ou des Centre de tri (en cas de retour) ;
              </li>
              <li>
                <strong>Recycleur : </strong>désigne l’entité sous contrat avec CITEO qui recycle les déchets issus du
                Centre de surtri. Le Recycleur peut réexpédier des déchets vers des Centres de tri ou des Centres de
                surtri s’il estime que la qualité des matières réceptionnées n’est pas suffisante ;
              </li>
              <li>
                <strong>Transporteur : </strong>désigne l’entité sous contrat avec CITEO qui planifie, collecte et livre
                les déchets au Centre de tri, Centre de surtri ou au Recycleur.
              </li>
            </ul>
          </Typography>
          <Typography variant="h3" className={classes.subTitle}>
            ACCEPTATION
          </Typography>
          <Typography>
            <strong>
              Toute utilisation de la Plateforme emporte acceptation pure et simple par l’Utilisateur et sans
              restriction des présentes Conditions générales d'utilisation et de leur contenu.
            </strong>
          </Typography>
          <Typography>
            L’acceptation des Conditions générales d’utilisation conditionne l’octroi à titre gratuit d’un droit
            révocable, non exclusif, non cessible, non transférable, et personnel d’utiliser la Plateforme pour une
            durée indéterminée et pour le monde entier. Sauf indication expresse contraire, ce droit d’utilisation
            exclut le droit pour l’Utilisateur de modifier, copier, traduire, diffuser, publier, transmettre,
            distribuer, produire, afficher ou céder les droits sur la Plateforme ou ses éléments à quelque titre que ce
            soit, directement ou indirectement, totalement ou partiellement, à titre onéreux ou gratuit. Le droit
            d’utilisation ainsi conféré ne peut être considéré comme un des éléments d’actif de l’Utilisateur.
          </Typography>
          <Typography>
            Il est précisé que l’Utilisateur qui utilise la Plateforme en tant que mandataire ou préposé d’une personne
            morale est réputé agir au nom et pour le compte de cette personne morale. L’acceptation des Conditions
            générales d’utilisation par cet Utilisateur est réputée faite au nom de cette personne morale.
          </Typography>
          <Typography>
            CITEO se réserve le droit de modifier unilatéralement, à tout moment et sans préavis tout ou partie des
            présentes Conditions générales d'utilisation ainsi que certaines fonctionnalités, notamment pour des raisons
            techniques. Les Conditions générales d’utilisation modifiées entrent en vigueur à compter de leur
            publication.
          </Typography>
          <Typography>
            Toute utilisation de la Plateforme après modification des présentes Conditions générales d’utilisation vaut
            acceptation pure et simple par l’Utilisateur des nouvelles Conditions générales d’utilisation. Il appartient
            donc à l’Utilisateur de consulter régulièrement les présentes pour prendre connaissance des termes et
            conditions en vigueur.
          </Typography>
          <Typography>
            <strong>
              L’Utilisateur s’engage à n’utiliser la Plateforme que dans le cadre de ses finalités décrites aux
              présentes Conditions générales d’utilisation.{' '}
            </strong>
            Toute utilisation de la Plateforme à des fins étrangères à celles mentionnées aux présentes est strictement
            interdite et pourra être sanctionnée nonobstant toute demande de dommages-intérêts que pourrait réclamer
            CITEO. En particulier, l’Utilisateur s’engage à utiliser les informations disponibles sur la Plateforme de
            manière licite et loyale et à ne pas accéder frauduleusement à la Plateforme ou perturber son
            fonctionnement.
          </Typography>
          <Typography variant="h3" className={classes.subTitle}>
            CONDITIONS D’ACCES ET D’UTILISATION
          </Typography>
          <Typography>
            L’utilisation de la Plateforme est subordonnée :
            <ul>
              <li>
                À l’utilisation d’un terminal (téléphone mobile, tablette, ordinateur …) et navigateur (versions les
                plus récentes de Chrome, Firefox, Opera, Safari, Edge) compatibles avec la Plateforme,
              </li>
              <li>À l’existence d’une connexion Internet suffisante à partir du terminal de l’Utilisateur,</li>
              <li>A l’acceptation sans réserve des Conditions générales d’utilisation,</li>
              <li>
                A la conclusion d’un contrat préalable avec Citeo ou à la conclusion d’un contrat de prestation de
                services avec une Collectivité sous contrat avec Citeo pour la reprise et le recyclage du flux
                développement
              </li>
              <li>A la création d’un compte utilisateur sur la Plateforme</li>
              <li>
                A l’utilisation d’un logiciel permettant la lecture d’un fichier sous format PDF, Word, Excel (licences
                non fournies par Citeo et restant à la charge exclusive de l’Utilisateur)
              </li>
            </ul>
            La Plateforme comporte plusieurs catégories d’Utilisateurs selon les profils :
            <ul>
              <li>
                <strong>Profil collectivité</strong> : permet la consultation et le téléchargement des informations
                concernant chaque Collectivité qui dispose d’un compte utilisateur ;
              </li>
              <li>
                <strong>Profil centre de tri</strong> : permet la consultation et le téléchargement des informations
                concernant chaque Centre de tri qui dispose d’un compte utilisateur ainsi que la création, modification
                et toute action sur une demande d’enlèvement de déchets ;
              </li>
              <li>
                <strong>Profil transporteur</strong> : permet la consultation et le téléchargement des informations
                concernant chaque Transporteur qui dispose d’un compte utilisateur ainsi que l’acceptation et la
                génération de la documentation des transports dont il est en charge ;
              </li>
              <li>
                <strong>Profil centre de surtri</strong> : permet la consultation et le téléchargement des informations
                concernant chaque Centre de surtri qui dispose d’un compte utilisateur ainsi que la création,
                modification et toute action sur une demande d’enlèvement, sur une réception, sur une déclaration de
                production et sur une campagne de surtri ;
              </li>
              <li>
                <strong>Profil recycleur</strong> : consultation et téléchargement des informations concernant chaque
                Recycleur qui dispose d’un compte utilisateur, création, modification et action sur une réception.
              </li>
            </ul>
            Les équipements et moyens matériels permettant d’accéder à la Plateforme sont à la charge exclusive de
            l’Utilisateur. L’Utilisateur prend notamment à sa charge les frais induits pour accéder, consulter et
            utiliser la Plateforme.
          </Typography>
          <Typography>
            L’impossibilité totale ou partielle d’utiliser la Plateforme notamment pour cause d’incompatibilité du
            terminal ou du navigateur ne peut donner lieu à aucun dédommagement ou mise en cause de la responsabilité de
            CITEO.
          </Typography>
          <Typography>
            <strong>
              L’utilisateur s’interdit tout usage non explicitement prévu par les Conditions générales d’utilisation, et
              notamment de modifier la Plateforme ou d’en extraire les informations ou données sauf dans les conditions
              décrites à l’article « Confidentialité » ci-après.
            </strong>
          </Typography>
          <Typography>
            L’utilisateur s’engage à :
            <ul>
              <li>
                Utiliser la Plateforme conformément à la réglementation en vigueur, à l’ordre public et aux présentes
                Conditions générales d’utilisation ;
              </li>
              <li>Ne pas utiliser la Plateforme de manière frauduleuse ou illégale ;</li>
              <li>
                Ne pas porter atteinte aux droits de tiers, notamment respecter les droits de propriété intellectuelle
                de CITEO ou de tiers (images, vidéos, sons ou tout autre élément protégé) auxquelles il aura accès du
                fait de l’utilisation de la Plateforme ;
              </li>
              <li>
                Faire un usage personnel de la Plateforme et à ne pas exploiter la Plateforme à des fins commerciales ;
              </li>
              <li>
                Ne fournir que des informations véritables et strictement nécessaires lors de ses contributions et à ne
                pas procéder à des signalements erronés quant aux contenus accessibles sur la Plateforme.
              </li>
            </ul>
            L’Utilisateur est responsable de tous les dommages causés par lui du fait de l’utilisation de la Plateforme.
            Il garantit CITEO contre toute demande ou réclamation de tiers qui invoqueraient une violation de leurs
            droits à la suite de l’utilisation faite par l’Utilisateur de la Plateforme.
          </Typography>
          <Typography>
            <strong>
              L’Utilisateur indemnisera CITEO de tout préjudice, dommage, perte ou frais (notamment honoraires
              d’avocats) liés à toute demande, action, plainte ou réclamation du fait du non-respect des présents
              Conditions générales d’utilisation.
            </strong>
          </Typography>
          <Typography variant="h3" className={classes.subTitle}>
            Donnees transmises par l'utilisateur
          </Typography>
          <Typography>
            L’Utilisateur est responsable des Données qu’il diffuse, envoie ou transmet par quelque moyen que ce soit
            par l’intermédiaire de la Plateforme.
          </Typography>
          <Typography>
            <strong>
              L’Utilisateur s’engage à ne saisir sur la Plateforme que des Données exactes et complètes et garantit
              qu’il dispose de l’ensemble des droits et autorisations nécessaires à la transmission et diffusion de ces
              Données.
            </strong>
          </Typography>
          <Typography>
            L’Utilisateur déclare et garantit à CITEO que le contenu diffusé par lui ne contrevient à aucune disposition
            légale, réglementaire ou contractuelle. Il s’engage expressément à indemniser CITEO de toutes les pertes
            exposées (en ce compris frais d’avocats) en cas de plainte / réclamation émise par toute personne du fait du
            contenu publié par lui.
          </Typography>
          <Typography>
            En particulier, l’Utilisateur s’interdit de publier tout contenu :
            <ul>
              <li>
                Contenant des éléments faux, diffamatoires, mensongers, dénigrants ou susceptibles de choquer et/ou
                porter atteinte à la réputation des tiers
              </li>
              <li>
                Susceptibles de porter atteinte à la vie privée, au secret des correspondances ou au droit à l’image
                d’un tiers
              </li>
              <li>
                Contenant des données à caractère personnel en violation des dispositions légales et réglementaires
                applicables
              </li>
              <li>
                Ne respectant pas les principes de neutralité politique, culturelle, religieuse ou constitutifs de
                jugement de valeur ou portant sur des données sensibles, références aux origines ethniques ou raciales,
                à l’appartenance syndicale, à la vie sexuelle et/ou aux mœurs des personnes
              </li>
              <li>
                Susceptible de constituer une atteinte à l’intégrité, au fonctionnement et à la disponibilité de la
                Plateforme, notamment (i) par la réalisation de fraudes informatiques, l’introduction de virus, l’envoi
                massif de spams ou autres éléments à caractère promotionnel non sollicités (ii) par l’accès non autorisé
                à la Plateforme ou (iii) par la collecte frauduleuse de données à caractère personnel.
              </li>
            </ul>
            Toute erreur de saisie ou demande de modification devra être gérée directement dans l’outil ou notifiée par
            courrier électronique à CITEO dans les meilleurs délais en vue de procéder à leur correction.
          </Typography>
          <Typography>
            Le contenu diffusé par l’utilisateur sur la Plateforme l’engage en son nom et ne peut engager à quelque
            titre que ce soit CITEO.
          </Typography>
          <Typography variant="h3" className={classes.subTitle}>
            Confidentialite
          </Typography>
          <Typography>
            CITEO s’engage à respecter la confidentialité des Données qui seront portées à sa connaissance et à faire
            respecter cette obligation de confidentialité par son personnel. Les Utilisateurs sont notamment informés
            que seul le personnel habilité de CITEO (en sa qualité de repreneur) ainsi que les autres Utilisateurs de la
            Plateforme, dans la mesure strictement nécessaire à leurs activités dans le cadre de la reprise du flux
            développement, ont accès aux Données pour les besoins de la gestion et du pilotage du flux développement.
            Les Utilisateurs peuvent exporter les Données les concernant mais s’engagent à ne pas communiquer ces
            Données à des tiers.
          </Typography>
          <Typography>
            Cet engagement ne concerne toutefois pas les informations et données que CITEO a l’obligation de transmettre
            à l’ADEME et/ou aux autorités compétentes conformément au cahier des charges d’agrément de la filière
            emballages ménagers, aux dispositions du code de l’environnement et/ou à l’arrêté du 20 décembre 2017
            relatif à la procédure d'enregistrement et de déclaration des données de la filière des déchets d'emballages
            ménagers ni les données communiquées de manière agrégée et consolidée dans le cadre des rapports d’activité
            de CITEO.
          </Typography>
          <Typography>
            Ne sont pas considérées comme confidentielles les données qui étaient notoirement et publiquement divulguées
            et/ou connues avant leur obtention ou réception par CITEO ou qui le deviendraient postérieurement sans faute
            de CITEO.
          </Typography>
          <Typography variant="h3" className={classes.subTitle}>
            DROITS DE PROPRIETE INTELLECTUELLE
          </Typography>
          <Typography>
            L'ensemble de la Plateforme et de son contenu relèvent de la législation française sur le droit d'auteur et
            la propriété intellectuelle (dessins et modèles, marques) et sont protégés à ce titre.
          </Typography>
          <Typography>
            L'ensemble du contenu de la Plateforme (architecture, charte graphique, textes, titres, photographies, sons,
            images illustrations, séquences animées sonores ou non, logiciels etc.) est la propriété exclusive de CITEO
            ou de ses prestataires et/ou partenaires ayant autorisé CITEO à les utiliser et/ou exploiter.
          </Typography>
          <Typography>
            Tous les droits de reproduction, de représentation et d’adaptation sont réservés, y compris pour les
            documents téléchargeables et les représentations iconographiques et photographiques.
          </Typography>
          <Typography>
            Conformément au code de la propriété intellectuelle,
            <strong>
              toute représentation, reproduction, modification, dénaturation, totale ou partielle, des pages, des
              données et de toute autre élément constitutif de la Plateforme,{' '}
            </strong>
            par quelque procédé ou support que ce soit, y compris pour les documents téléchargeables et les
            représentations iconographiques et photographiques est <strong>interdite</strong> et constitue,{' '}
            <strong>sans autorisation préalable de CITEO ou des titulaires des droits</strong> un délit de contrefaçon
            pouvant engager la responsabilité civile et pénale de son auteur.
          </Typography>
          <Typography>
            Est également pénalement sanctionnable, toute reproduction sans autorisation préalable et expresse du
            directeur de la publication, des marques éventuellement citées ou qui apparaissent sur la Plateforme qui
            sont des marques déposées par les sociétés qui en sont propriétaires.
          </Typography>
          <Typography>
            Toute reproduction ou représentation de tout ou partie de la Plateforme autorisée conformément aux présentes
            Conditions générales d'utilisation devra comporter les mentions de droits d'auteur/de propriété figurant sur
            les documents reproduits.
          </Typography>
          <Typography variant="h3" className={classes.subTitle}>
            SECURITE ET DISPONIBILITE DE LA PLATEFORME
          </Typography>
          <Typography>
            L’accès à la Plateforme est ouvert 24 heures sur 24, 7 jours sur 7. CITEO fait ses meilleurs efforts pour
            assurer l’accessibilité continue à la Plateforme et son bon fonctionnement.
          </Typography>
          <Typography>
            CITEO fera tous ses efforts pour assurer son obligation générale de protection et de sécurité de la
            Plateforme et des données qui le composent. Toutefois, l’Utilisateur admet connaître les limitations propres
            au réseau Internet et reconnaît l’impossibilité d’une garantie totale de sécurisation des échanges de
            données contre les risques de détournement ou de piratage.
          </Typography>
          <Typography>
            <strong>
              CITEO ne saurait garantir que le fonctionnement de la Plateforme sera ininterrompu et/ou que son contenu
              est exempt de toute erreur.
            </strong>
          </Typography>
          <Typography>
            Les Utilisateurs sont notamment informés que la Plateforme pourra être suspendu sans préavis pour des
            opérations de maintenance et de mises à jour des données nécessaires à son bon fonctionnement. CITEO pourra
            également procéder au retrait de la Plateforme en cas d’obsolescence ou d’inadaptation de la Plateforme ou
            de décision d’abandon de son exploitation pour toute autre raison que ce soit. Cette fermeture de la
            Plateforme n’ouvrira droit à aucun dommages et intérêts pour les Utilisateurs.
          </Typography>
          <Typography>
            CITEO ne saurait être tenue responsable des dysfonctionnements et/ou interruptions de la Plateforme
            résultant des opérations effectuées par l’Utilisateur, ou en cas d’interruption résultant de toute cause
            extérieure, telle que notamment l’interruption résultant d’une absence de courant ou d’alimentation
            électrique, ou encore d’une interruption de connexion Internet.
          </Typography>
          <Typography variant="h3" className={classes.subTitle}>
            COMPTES PERSONNELS D’UTILISATION
          </Typography>
          <Typography>
            L’Utilisateur dispose d’accès personnalisés à son compte, protégé via son identifiant et mot de passe.
          </Typography>
          <Typography>
            Pour créer un compte utilisateur, l’utilisateur a deux possibilités :
            <ul>
              <li>
                Adresser une demande par mail à Citeo à l’adresse : flux.developpement@citeo.com en indiquant une
                adresse mail valide ;
              </li>
              <li>
                Création de compte sur la Plateforme en renseignant une adresse mail valide ainsi qu’un mot de passe
                (fonctionnalité à venir)
              </li>
            </ul>
          </Typography>
          <Typography>
            La création du compte utilisateur est subordonnée à l’acceptation des Conditions générales d’utilisation.
            Toute utilisation de la Plateforme en violation des présentes pourra être sanctionnée, notamment par la
            fermeture du compte utilisateur, nonobstant toute demande de dommages-intérêts que pourrait réclamer CITEO.
          </Typography>
          <Typography>
            Les données d’identification (identifiant, mot de passe) sont personnelles et uniques à chaque Utilisateur.
            Ces données sont <strong>confidentielles et non transmissibles. </strong>Elles sont placées sous la
            responsabilité de chaque Utilisateur et il lui revient d'en préserver la stricte confidentialité.
          </Typography>
          <Typography>
            CITEO veillera également à assurer leur confidentialité et à ne les communiquer qu’aux Utilisateurs
            appropriés.
          </Typography>
          <Typography>
            <strong>
              Chaque Utilisateur est seul responsable de la gestion, de la conservation et des conséquences de
              l’utilisation de ses identifiants pour accéder à la Plateforme et s’engage à prendre toutes les
              précautions nécessaires pour éviter leur utilisation frauduleuse.
            </strong>
          </Typography>
          <Typography>
            Tout accès ou utilisation du compte de l’Utilisateur est réputé avoir été effectué par l’Utilisateur. A cet
            égard, il est recommandé à l’Utilisateur de s’assurer qu’à l’issue de chaque session, il se déconnecte
            effectivement de son compte utilisateur.
          </Typography>
          <Typography>
            En cas de perte, d’oubli ou d’utilisation frauduleuse de ses identifiants, l’Utilisateur s’engage à en
            notifier CITEO sans délai par le moyen le plus approprié (formulaire de renouvellement mis à disposition,
            téléphone ou courrier électronique) et, le cas échéant, à le confirmer sans délai par écrit. L’Utilisateur
            sera seul responsable des conséquences de l’utilisation frauduleuse des données d’identification tant que
            CITEO n’aura pas reçu une telle confirmation écrite.
          </Typography>
          <Typography>
            L’Utilisateur s’engage à mettre en place tous les moyens à sa disposition, y compris ceux éventuellement
            prescrits par CITEO, pour faire cesser ces agissements et/ou en limiter les conséquences.
          </Typography>
          <Typography>
            En tout état de cause, dès que CITEO a connaissance d’une utilisation frauduleuse des données
            d’identification, elle s’engage à mettre en place tous les moyens à sa disposition pour faire cesser ces
            agissements et/ou pour en limiter les conséquences. En conséquence, CITEO se réserver le droit, en tant que
            de besoin, de suspendre de manière temporaire ou d’interrompre l’accès à la Plateforme en cas de doute sur
            l’authenticité de l’identification ou en cas de tentative d’intrusion.
          </Typography>
          <Typography>
            CITEO se réserve le droit de suspendre ou de fermer le compte d’un Utilisateur ou un accès individualisé en
            cas de manquement de sa part aux présentes Conditions générales d’utilisation (notamment les conditions
            d’accès et de sécurité) ou d’injonction judiciaire.
          </Typography>
          <Typography>
            CITEO se réserve le droit d’exercer toute action conforme à la préservation de ses intérêts à l’encontre de
            l’Utilisateur à l’origine d’une violation des présentes Conditions générales d’utilisation ou d’un problème
            de sécurité.
          </Typography>
          <Typography variant="h3" className={classes.subTitle}>
            RESPONSABILITE
          </Typography>
          <Typography>
            CITEO sera responsable, au titre d’une obligation générale de moyens, des seuls dommages matériels directs
            prouvés par l’Utilisateur et résultant d’une non-conformité de la Plateforme aux principes présentés dans
            les présentes Conditions générales d’utilisation.
          </Typography>
          <Typography>
            Par ailleurs, CITEO n’assume en aucun cas la responsabilité des dommages matériels indirects et des dommages
            immatériels directs et indirects résultant de l’utilisation de la Plateforme, de la perte, l'altération,
            l'effacement des éléments et/ou documents ou l'accès frauduleux à des Données ou informations
            confidentielles de l’Utilisateur.
          </Typography>
          <Typography>
            Par dommages indirects il faut entendre en particulier : gain manqué, perte d’image de marque, corruption ou
            perte de fichiers, de données ou de programmes informatiques qui pourraient résulter notamment d’une
            défaillance ou de l’utilisation de la Plateforme. Est assimilée à un préjudice indirect et en conséquence
            n’ouvre pas droit à réparation, toute action dirigée contre l’Utilisateur par un tiers.
          </Typography>
          <Typography>
            CITEO, ses dirigeants ou salariés ne sauraient être tenus pour responsables des dommages, directs ou
            indirects, commerciaux ou non, provenant :
            <ul>
              <li>
                D’une connexion et de l’utilisation de la Plateforme (bug, erreur, inexactitude, omission sur les
                informations disponibles, absence de disponibilité des fonctionnalités, …) ;
              </li>
              <li>
                De toute interruption ou indisponibilité totale ou partielle de la Plateforme pour quelque cause que ce
                soit, notamment due à des opérations de maintenance ou à des problèmes techniques ;
              </li>
              <li>
                D’une utilisation de la Plateforme non conforme aux Conditions générales d’utilisation ou à la loi ;
              </li>
              <li>D’erreurs de l’Utilisateur telles que l’entrée de données fausses ou erronées ;</li>
              <li>
                D’une intrusion frauduleuse d’un tiers ayant entraîné une modification des informations mises à
                disposition sur la Plateforme.
              </li>
            </ul>
          </Typography>
          <Typography>
            De même CITEO ne saurait être tenue pour responsable pour des faits dus à un évènement de force majeure, les
            pannes et les problèmes d'ordre technique concernant le matériel, les programmes et logiciels ou le réseau
            Internet pouvant le cas échéant entrainer la suspension ou la cessation de la Plateforme.
          </Typography>
          <Typography>
            En outre, CITEO ne garantit pas le fait que le serveur accueillant cette Plateforme soit exempt de virus ou
            qu'il puisse survenir un problème technique qui nuise à un usage normal de la Plateforme.
          </Typography>
          <Typography>
            CITEO se réserve la possibilité de modifier, suspendre ou interrompre la diffusion de tout ou partie de la
            Plateforme.
          </Typography>
          <Typography>
            CITEO ne sera notamment pas responsable des dommages provoqués par :
            <ul>
              <li>
                Le propre fait de l’Utilisateur, omission ou faute (par exemple mauvaise utilisation, mauvaise
                configuration du terminal, emploi d’un navigateur obsolète…) ;
              </li>
              <li>
                Tout tiers non lié à CITEO (par exemple, dans le cas où les problèmes résulteraient des performances, de
                la congestion ou de la connexion des moyens ou services de télécommunications, ou de la performance de
                l’équipement informatique de l’Utilisateur).
              </li>
            </ul>
          </Typography>
          <Typography>
            L’Utilisateur reconnaît utiliser la Plateforme sous sa responsabilité exclusive et doit vérifier
            l’exactitude, la pertinence et la cohérence des informations et données disponibles sur la Plateforme.
            L’utilisation des informations et données de la Plateforme et toutes décisions prises sur la foi de ces
            informations et données seront de la seule et unique responsabilité de l’Utilisateur.
          </Typography>
          <Typography>
            Bien qu’elle s’efforce de fournir un contenu fiable, CITEO ne garantit pas l’exactitude, la complétude ou
            l’exhaustivité des informations présentes sur la Plateforme et ne pourra être tenue responsable à quelque
            titre que ce soit d’une mauvaise utilisation de la Plateforme ou de tout dommage résultat de toute erreur,
            inexactitude, incohérence, imprécision de son contenu.
          </Typography>
          <Typography variant="h3" className={classes.subTitle}>
            LIENS HYPERTEXTES
          </Typography>
          <Typography>
            La Plateforme peut comporter des liens vers d'autres sites appartenant à des tiers.{' '}
            <strong>
              Ces liens ne constituent en aucune manière une approbation, une validation, une adhésion de CITEO au
              contenu de ces sites ni une association de CITEO avec les responsables administrateurs, auteurs ou
              hébergeurs de ces sites et ne sauraient engager la responsabilité de CITEO.
            </strong>
          </Typography>
          <Typography>
            CITEO n'éditant ni ne contrôlant les sources, les contenus ou les liens présents sur ces sites, ne saurait
            dès lors être tenue pour responsable du contenu, fonctionnement et de l'accès à ces sites ou de tous
            dommages ou pertes, avérés ou allégués, consécutifs ou en relation avec l'utilisation des informations,
            services ou données disponibles sur ces sites.
          </Typography>
          <Typography variant="h3" className={classes.subTitle}>
            LOI APPLICABLE
          </Typography>
          <Typography>
            La Plateforme et les présentes Conditions générales d'utilisation sont régies par la loi française.
          </Typography>
          <Typography>
            Toute utilisation de la Plateforme doit l'être dans des conditions respectant les présentes et sera réputée
            être intervenue sur le territoire français.
          </Typography>
          <Typography>
            <strong>
              CITEO se réserve le droit d'entreprendre des actions en justice contre les personnes agissant d'une
              manière pouvant être considérée comme illégale ou illicite ou contrevenant aux présentes conditions.
            </strong>
          </Typography>
          <Typography>
            Tout différend relatif à l'interprétation, la formation, l'exécution ou la résiliation des présentes
            conditions générales d'utilisation d'une tentative préalable de règlement amiable entre les parties.
          </Typography>
          <Typography>
            A défaut de règlement amiable, le différend pourra être porté devant la juridiction compétente du ressort de
            Paris.
          </Typography>
        </Paper>
      </div>
    </Layout>
  );
};

export default TermsOfUse;
